import { HEADER_HEIGHT } from "@/constants/components";
import { Box } from "@chakra-ui/react";
import { customEvent, EventTriggerAndTargetType } from "goi_common";
import { useRouter } from "next/router";
import { ArticleSummary } from "pages/guidebook";
import { useCallback, useEffect, useState } from "react";
import { GuidebookInquiries } from "./GuidebookInquiries";
import { GuidebookThumbnails } from "./GuidebookThumbnails";
import { QuestionDrawer } from "./QuestionDrawer";
import { TabMenu } from "@/components/TabMenu";
import { useGuidebookQuestion } from "@/containers/GuidebookTipContainer/hooks/useGuidebookQuestion";

interface GuidebookMainTabsProps {
  keyword?: string;
  articles?: ArticleSummary[];
}
export function GuidebookMainTabs({ keyword, articles }: GuidebookMainTabsProps) {
  const router = useRouter();

  const handleTabChange = useCallback(
    (value: "all" | "qna") => {
      const path: "guidebook" | "guidebook_search" = router.asPath.includes("search")
        ? "guidebook_search"
        : "guidebook";
      customEvent({
        newGtm: {
          path,
          trigger_and_target: `tab_${value}-tab_${value}` as EventTriggerAndTargetType["guidebook"],
        },
      });
      router.replace(
        {
          pathname: router.pathname,
          query: { ...router.query, tab: value },
        },
        undefined,
        { scroll: false },
      );
    },
    [router],
  );

  const [current, setCurrent] = useState<"all" | "qna">("all");

  useEffect(() => {
    if (!router.isReady) return;

    if (router.query.tab === "all") return setCurrent("all");
    if (router.query.tab === "qna") return setCurrent("qna");
  }, [router.isReady, router.query.tab]);

  const { isOpenQuestioDrawer, edit, handleCloseQuestioDrawer } = useGuidebookQuestion();

  if (!router.isReady || !current) return null;

  return (
    <>
      <Box marginTop="12px" id="mainTab" scrollMarginTop={`${HEADER_HEIGHT}px`}>
        <TabMenu
          items={[
            { key: "가이드북 전체", value: "all" },
            { key: "사람들의 질문", value: "qna" },
          ]}
          iconNames={{
            all: "guidebook",
            qna: "inquiry",
          }}
          value={current}
          onChange={handleTabChange}
        />
        {current === "all" && <GuidebookThumbnails keyword={keyword} articles={articles} />}
        {current === "qna" && <GuidebookInquiries keyword={keyword} />}
      </Box>

      <QuestionDrawer id={edit} isOpen={isOpenQuestioDrawer} onClose={handleCloseQuestioDrawer} />
    </>
  );
}
